import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { RankingComponent } from './views/ranking/ranking.component';
import { SocketService } from './services/socket.service';
import { QrComponent } from './views/qr/qr.component';
import { BannerComponent } from './views/banner/banner.component';


@NgModule({
  declarations: [
    AppComponent,
    RankingComponent,
    QrComponent,
    BannerComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [
    SocketService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /app/src/app/app.module.ts